import api from './api';

export interface QuickReceiveInputLine {
  inventoryItemId: string;
  supplierId: string;
  receivedQty: number;
  unitCost?: number;
}

export interface QuickReceivePayload {
  /** The VenueLocation where received stock is placed. Required. */
  locationId: string;
  receivedDate: string;
  receivedBy: string;
  notes?: string;
  ownershipAccountId?: string;
  lines: QuickReceiveInputLine[];
}

export interface QuickReceiveGroupResult {
  supplierId: string;
  purchaseOrderId: string;
  goodsReceiptId: string;
  linesPosted: number;
  movementsCreated: number;
  poStatus: string;
}

export interface QuickReceiveGroupFailure {
  supplierId: string;
  error: string;
  code: string;
}

export interface QuickReceiveResult {
  results: QuickReceiveGroupResult[];
  failed: QuickReceiveGroupFailure[];
  totalMovementsCreated: number;
  summary: string;
}

const quickReceiveService = {
  /**
   * Quick receive against an assigned venue. Hits the venue-scoped mount
   * (`/admin/venue/:venueId/quick-receive`); the controller derives venueId
   * from the URL, so body.venueId is no longer needed. Backend gates this
   * route via venueAccessMiddleware so VENUE_USER is restricted to assigned
   * venues automatically.
   */
  submit: async (venueId: string, payload: QuickReceivePayload): Promise<QuickReceiveResult> => {
    const response = await api.post(`/admin/venue/${venueId}/quick-receive`, payload);
    return response.data;
  },
};

export default quickReceiveService;
